"use client"
import type { ButtonHTMLAttributes } from "react"
import "./scenic-switch.css"

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> & {
  checked?: boolean
  onChange?: (checked: boolean) => void
  size?: "small" | "default"
}

export function ScenicSwitch({checked=false, onChange, size: _size, className="", ...props}: Props) {
  return <button {...props} type="button" role="switch" aria-checked={checked}
    className={`scenic-switch ${className}`} onClick={()=>onChange?.(!checked)}>
    <span className="scenic-track" aria-hidden="true">
      <span className="scenic-clouds" />
      <svg className="scenic-stars" viewBox="0 0 60 30">
        {[ [7,7,2],[20,19,2.5],[31,5,1.8],[44,15,2],[12,27,1],[38,27,1.2],[52,4,1] ].map(([x,y,r],i)=><path key={i} d={`M ${x} ${y-r} Q ${x} ${y} ${x+r} ${y} Q ${x} ${y} ${x} ${y+r} Q ${x} ${y} ${x-r} ${y} Q ${x} ${y} ${x} ${y-r}`} fill="currentColor" />)}
      </svg>
      <span className="scenic-circle"><span className="scenic-sun"><span className="scenic-moon"><i/><i/><i/></span></span></span>
    </span>
  </button>
}
